import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortDown, faTrophy } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'gatsby';

// Constants
import { ColorsVariables } from '../../../../assets/styles/colors';

// Functions
import { fetchHighScore } from '../../../../lib/apiHelpers';

// Lib
import { GAME_MODE_NAMES, GAME_MODES } from '../lib/constants/modes';

// Global Atoms
import { Flex } from '../../../Atoms/Flex-Grid';
import { Divider } from '../../../Atoms/Dividers';
import { HeavyText, GreenText } from '../../../Atoms/Texts';
import { RedText } from '../components/Yamb.atoms';
import { Heading } from '../../../Atoms/Heading';
import { Button } from '../../../Atoms/Buttons';
import { Paragraph } from '../../../Atoms/Paragraph';

// Molecules
import RadioButton from '../../../Molecules/RadioButton/RadioButton';
import Section from '../../../Molecules/Section/Section';

const HighScoreScreen = (props) => {
	const {
		type,
	} = props;
	const [gameMode, setGameColumns] = useState(GAME_MODE_NAMES[GAME_MODES.COLUMNS_10]);
	const [highScoreData, setHighScoreData] = useState([]);
	const [serverError, setServerError] = useState(null);

	useEffect(() => {
		fetchHighScore(gameMode, type, setHighScoreData, setServerError);
	}, [gameMode, type]);

	return (
		<>
			<Section>
				<Heading padding="bs tm">
					<FontAwesomeIcon icon={faTrophy} color={ColorsVariables.MainGreen} style={{ maxHeight: '28px', maxWidth: '32px' }} />
					{' '}
					High Score
				</Heading>
				<Paragraph padding="bl" scale="true">
					Scores made by people over some time period.
				</Paragraph>
				<Flex autoHeight mobile="wrap">
					<Button as={Link} to="/yamb/hall-of-fame" href="/yamb/hall-of-fame" type={type === 'all' ? 'standard' : 'outline'} mobile="fluid">All</Button>
					<Button as={Link} to="/yamb/hall-of-fame/weekly" href="/yamb/hall-of-fame/weekly" type={type === 'weekly' ? 'standard' : 'outline'} mobile="fluid">Weekly</Button>
					<Button as={Link} to="/yamb/hall-of-fame/daily" href="/yamb/hall-of-fame/daily" type={type === 'daily' ? 'standard' : 'outline'} mobile="fluid">Daily</Button>
				</Flex>
			</Section>
			<Section>
				<Flex justify="center" align="flex-start" padding="txl" mobile="wrap COLUMN_REVERSE" autoHeight scale="true">
					<Flex direction="column" justify="flex-start" autoHeight autoWidth padding="rxl" mobile="no_side_spacing">
						<Flex justify="flex-start" autoWidth autoHeight padding="bs">
							<Heading as="h6">Choose Game Type</Heading>
							<Divider.VerticalDivider width="10" />
							<FontAwesomeIcon icon={faSortDown} color="rgba(147,228,182,1)" />
						</Flex>
						<RadioButton
							options={Object.values(GAME_MODE_NAMES)}
							name="gameMode"
							initialState={gameMode}
							onChange={value => setGameColumns(value)}
						/>
					</Flex>
					<Flex justify="space-evenly" align="flex-start" autoHeight direction="column" autoWidth margin="bm">
						<RedText>{serverError}</RedText>
						{!highScoreData[0] && !serverError && (
							<Paragraph padding="txs bs">
								No data for this mode
							</Paragraph>
						)}
						{highScoreData[0] && highScoreData?.map(item => (
							<Flex justify="flex-start" padding="bs">
								<Paragraph padding="rs">
									{item.name}
								</Paragraph>
								<HeavyText><GreenText>{item.score}</GreenText></HeavyText>
							</Flex>
						))}
					</Flex>
				</Flex>
			</Section>
		</>
	);
};

HighScoreScreen.propTypes = {
	type: PropTypes.oneOf(['all', 'weekly', 'daily']).isRequired,
};

export default HighScoreScreen;
